import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: null,
  fName: '',
  lName: '',
  email: '',
  position: '',
  pic: '',
  isLoggedIn: false,
};

const coordinatorSlice = createSlice({
  name: 'coordinator',
  initialState,
  reducers: {
    setCoordinator: (state, action) => {
      const { id, fName, lName, email, position, pic } = action.payload;
      state.id = id;
      state.fName = fName;
      state.lName = lName;
      state.email = email;
      state.position = position;
      state.pic = pic;
      state.isLoggedIn = true;
    },
    logoutCoordinator: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const { setCoordinator, logoutCoordinator } = coordinatorSlice.actions;
export default coordinatorSlice.reducer;
